var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"diagonal-guide-txt",class:{ isPaidy: _vm.isPaidy },style:({
    top: `${_vm.top}px`,
    height: `${_vm.$store.state.camera.headerMarginHeight}px`
  })},[_c('div',[_vm._v(_vm._s(_vm.sentences[0]))]),_c('div',{class:{ 'color-old': _vm.isIdDocPassport }},[_c('span',[_vm._v(_vm._s(_vm.sentences[1]))]),_vm._v(" "+_vm._s(_vm.sentences[2])+" "),_c('span',[_vm._v(_vm._s(_vm.sentences[3]))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }